<mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="settings-header">{{ translations.sidenav.settings | translate }}</h2>
    <button
            class="clear-btn"
            mat-icon-button
            aria-label="Clear"
            (click)="close()">
        <mat-icon>clear</mat-icon>
    </button>
</mat-dialog-title>

<mat-dialog-content class="settings-wrapper">
    <app-settings [isMobileView]="true"></app-settings>
</mat-dialog-content>

